import { CommentSorting } from "@/Types/generated_enums";

export const CommentSortingLabel = new Map<CommentSorting, string>([
  [CommentSorting.Popular, "Most Popular"],
  [CommentSorting.Recent, "Most Recent"],
]);
